import { render, staticRenderFns, recyclableRender, components } from "./details_dispatch_unit.vue?vue&type=template&id=621987a0&scoped=true&"
var renderjs
import script from "./details_dispatch_unit.vue?vue&type=script&lang=js&"
export * from "./details_dispatch_unit.vue?vue&type=script&lang=js&"
import style0 from "./details_dispatch_unit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./details_dispatch_unit.vue?vue&type=style&index=1&id=621987a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621987a0",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/details_dispatch_unit/details_dispatch_unit.vue"
export default component.exports